import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "requestStatus", "setLoading"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect } from 'react';
import { EmbersLoading as Loading } from './loading';
import { useTwoSecondsLoading } from './useTwoSecondsLoading';
export var EmbersTwoSecondsLoading = function EmbersTwoSecondsLoading(props) {
  var loading = props.loading,
    requestStatus = props.requestStatus,
    setLoading = props.setLoading,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useTwoSecondsLoading = useTwoSecondsLoading({
      setLoading: setLoading
    }),
    handleTwoSecondLoading = _useTwoSecondsLoading.handleTwoSecondLoading,
    timeout = _useTwoSecondsLoading.timeout;
  useEffect(function () {
    // Only when you set setLoading can it apply this hook, otherwise it just renders a pure Loading component
    if (requestStatus !== undefined && setLoading) handleTwoSecondLoading(requestStatus);
  }, [requestStatus]);
  useEffect(function () {
    return function () {
      if (timeout.current) clearTimeout(timeout.current);
    };
  }, []);
  if (!loading) return null;
  return /*#__PURE__*/React.createElement(Loading, otherProps);
};